import { render, staticRenderFns } from "./yuechengxing.vue?vue&type=template&id=2e155789&scoped=true&"
import script from "./yuechengxing.vue?vue&type=script&lang=js&"
export * from "./yuechengxing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e155789",
  null
  
)

export default component.exports